<template>
    <div v-if="!loading">
        <highcharts
            :constructor-type="'chart'"
            :options="chartOptions"
            class="chart"
            ref="highcharts"
        ></highcharts>
    </div>
    <div class="text-center pt-3 pb-3" v-else>
        <img src="loader.svg" style="width: 100px; height: 100px" />
    </div>
</template>

<script>
import Utils from '@/utils'
import ChartsConfig from '@/mixins/Charts.Config.js'
export default {
    props: {
        data: {
            type: [Array],
            require: true
        },
        loading: {
            type: Boolean,
            require: true
        },
        onHandle: {
            type: [Function],
            require: true
        }
    },

    data() {
        return {
            item_color: '',
            item_name: '',
            chartOptions: {
                chart: {
                    type: 'pie',
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    className: 'pie_chart_resize'
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: 'Valores'
                    },
                    labels: {
                        formatter: function() {
                            return Utils.formatNumber(this.value, 'float', true)
                        }
                    }
                },
                tooltip: {
                    formatter: function() {
                        return `<span style="color:${this.color}">\u25CF</span>
                        total de cubagem: <b>${Utils.formatNumber(
                            this.y,
                            'float',
                            true
                        )}</b><br />
                        <span style="color:${this.color}">\u25CF</span>
                        percentual sobre o total: <b>${Utils.formatNumber(
                            this.point.percentage_cubage,
                            'float',
                            true
                        )}%</b>`
                    }
                },
                plotOptions: {
                    column: {
                        stacking: 'normal',
                        dataLabels: {
                            enabled: true,
                            formatter: function() {
                                return Utils.formatNumber(this.y, 'float', true)
                            }
                        }
                    }
                },
                title: {
                    text: 'Gráfico de Pizza Cubagem'
                },
                series: []
            }
        }
    },
    mixins: [ChartsConfig],
    watch: {
        data: {
            handler: function(data) {
                this.$nextTick(() => {
                    const chart = this.$refs.highcharts.chart

                    while (chart.series.length) {
                        chart.series[0].remove()
                    }

                    const total = data[0].filter(
                        item => item.curve === 'Total'
                    )[0].stock_cubage

                    const total_without_new_cubage = data[0].filter(
                        item => item.curve === 'Total'
                    )[0].total_without_new_cubage

                    const series = {
                        name: 'cubagens',
                        colorByPoint: true,
                        data: data[0].map(item => {
                            if (item.curve !== 'Total') {
                                if (data[1].isChecked === true) {
                                    var item_percentage = (
                                        (item.stock_cubage / total) *
                                        100
                                    ).toFixed(2)
                                    if (item.curve === 'AA') {
                                        this.item_color = '#00FF00'
                                        if ((item.stock_cubage / total) * 100) {
                                            this.item_name =
                                                item.curve +
                                                '<br>' +
                                                item_percentage +
                                                '%'
                                        } else {
                                            this.item_name = item.curve + ' 0%'
                                        }
                                    } else if (item.curve === 'A') {
                                        this.item_color = '#0AC20A'
                                        if ((item.stock_cubage / total) * 100) {
                                            this.item_name =
                                                item.curve +
                                                '<br>' +
                                                item_percentage +
                                                '%'
                                        } else {
                                            this.item_name = item.curve + ' 0%'
                                        }
                                    } else if (item.curve === 'B') {
                                        this.item_color = '#FFFF00'
                                        if ((item.stock_cubage / total) * 100) {
                                            this.item_name =
                                                item.curve +
                                                '<br>' +
                                                item_percentage +
                                                '%'
                                        } else {
                                            this.item_name = item.curve + ' 0%'
                                        }
                                    } else if (item.curve === 'C') {
                                        this.item_color = '#D90808'
                                        if ((item.stock_cubage / total) * 100) {
                                            this.item_name =
                                                item.curve +
                                                '<br>' +
                                                item_percentage +
                                                '%'
                                        } else {
                                            this.item_name = item.curve + ' 0%'
                                        }
                                    } else {
                                        this.item_color = '#FF0000'
                                        if ((item.stock_cubage / total) * 100) {
                                            this.item_name =
                                                item.curve +
                                                '<br>' +
                                                item_percentage +
                                                '%'
                                        } else {
                                            this.item_name = item.curve + ' 0%'
                                        }
                                    }

                                    return {
                                        name: this.item_name,
                                        percentage_cubage: item_percentage,
                                        y: item.stock_cubage,
                                        color: this.item_color,
                                        events: {
                                            click: event => {
                                                this.onHandle(event.point.name)
                                            }
                                        }
                                    }
                                } else {
                                    var item_percentage = (
                                        (item.total_without_new_cubage /
                                            total) *
                                        100
                                    ).toFixed(2)
                                    if (item.curve === 'AA') {
                                        this.item_color = '#00FF00'
                                        if (
                                            (item.total_without_new_cubage /
                                                total) *
                                            100
                                        ) {
                                            this.item_name =
                                                item.curve +
                                                '<br>' +
                                                item_percentage +
                                                '%'
                                        } else {
                                            this.item_name = item.curve + ' 0%'
                                        }
                                    } else if (item.curve === 'A') {
                                        this.item_color = '#0AC20A'
                                        if (
                                            (item.total_without_new_cubage /
                                                total) *
                                            100
                                        ) {
                                            this.item_name =
                                                item.curve +
                                                '<br>' +
                                                item_percentage +
                                                '%'
                                        } else {
                                            this.item_name = item.curve + ' 0%'
                                        }
                                    } else if (item.curve === 'B') {
                                        this.item_color = '#FFFF00'
                                        if (
                                            (item.total_without_new_cubage /
                                                total) *
                                            100
                                        ) {
                                            this.item_name =
                                                item.curve +
                                                '<br>' +
                                                item_percentage +
                                                '%'
                                        } else {
                                            this.item_name = item.curve + ' 0%'
                                        }
                                    } else if (item.curve === 'C') {
                                        this.item_color = '#D90808'
                                        if (
                                            (item.total_without_new_cubage /
                                                total) *
                                            100
                                        ) {
                                            this.item_name =
                                                item.curve +
                                                '<br>' +
                                                item_percentage +
                                                '%'
                                        } else {
                                            this.item_name = item.curve + ' 0%'
                                        }
                                    } else {
                                        this.item_color = '#FF0000'
                                        if (
                                            (item.total_without_new_cubage /
                                                total) *
                                            100
                                        ) {
                                            this.item_name =
                                                item.curve +
                                                '<br>' +
                                                item_percentage +
                                                '%'
                                        } else {
                                            this.item_name = item.curve + ' 0%'
                                        }
                                    }

                                    return {
                                        name: this.item_name,
                                        percentage_cubage: item_percentage,
                                        y: item.total_without_new_cubage,
                                        color: this.item_color,
                                        events: {
                                            click: event => {
                                                this.onHandle(event.point.name)
                                            }
                                        }
                                    }
                                }
                            }
                        })
                    }

                    chart.addSeries(series)
                })
            },
            deep: true
        }
    }
}
</script>
<style scoped>
.highcharts-figure,
.highcharts-data-table table {
    min-width: 310px;
    max-width: 800px;
    margin: 1em auto;
}

.highcharts-data-table table {
    font-family: Verdana, sans-serif;
    border-collapse: collapse;
    border: 1px solid #ebebeb;
    margin: 10px auto;
    text-align: center;
    width: 100%;
    max-width: 500px;
}

.highcharts-data-table caption {
    padding: 1em 0;
    font-size: 1.2em;
    color: #555;
}

.highcharts-data-table th {
    font-weight: 600;
    padding: 0.5em;
}

.highcharts-data-table td,
.highcharts-data-table th,
.highcharts-data-table caption {
    padding: 0.5em;
}

.highcharts-data-table thead tr,
.highcharts-data-table tr:nth-child(even) {
    background: #f8f8f8;
}

.highcharts-data-table tr:hover {
    background: #f1f7ff;
}
</style>
